import React from 'react';
import { DroneIcon } from 'components/icons';
import {
  VideoFrame,
  VideoLabel,
} from 'containers/jobsite/tabs/jobsitePulse/components/cameras/video';
import { DroneCamera } from './types';
import { useDroneDeploy } from './DroneDeployContext';
import { DRONE_FEED_URL } from './droneDemoData';

const droneStatusLabels: Record<string, string> = {
  idle: 'Idle',
  'in-flight': 'In Flight',
  returning: 'Returning',
  offline: 'Offline',
};

export function DroneCameraListItem(props: {
  cam: DroneCamera;
  isSelected: boolean;
  onSelect: () => void;
  className?: string;
}): React.ReactElement {
  const { cam, isSelected, onSelect, className } = props;
  const droneDeploy = useDroneDeploy();

  const displayStatus =
    // eslint-disable-next-line no-nested-ternary
    isSelected && droneDeploy?.phase === 'deploying'
      ? 'Deploying...'
      : isSelected && droneDeploy?.phase === 'ready'
      ? 'In Flight'
      : droneStatusLabels[cam.droneStatus] ?? 'Idle';

  const showThumbnail = isSelected && droneDeploy?.phase === 'ready';

  return (
    <VideoFrame onClickVideo={onSelect} className={className}>
      <VideoLabel text={cam.name} isSelected={isSelected} />
      {showThumbnail ? (
        <video
          src={DRONE_FEED_URL}
          className="odin-w-full odin-h-full odin-object-cover"
          muted
        />
      ) : (
        <div className="odin-aspect-video odin-flex odin-flex-col odin-items-center odin-justify-center odin-gap-1">
          <DroneIcon
            className={`odin-h-8 odin-w-8 ${
              isSelected && droneDeploy?.phase === 'deploying'
                ? 'odin-text-purple-400 odin-animate-pulse'
                : 'odin-text-slate-400'
            }`}
          />
          <span
            className={`odin-text-xs ${
              isSelected && droneDeploy?.phase === 'deploying'
                ? 'odin-text-purple-300'
                : 'odin-text-slate-400'
            }`}
          >
            {displayStatus}
          </span>
        </div>
      )}
    </VideoFrame>
  );
}
